<template>
	<div
		class="prebuild-game"
		:class="{ 'prebuild-game--reverse-content': reverseContent }"
	>
		<fps-bar :fps="game.fps[resolution]" />
		<div class="prebuild-game__cover">
			<img :src="game.high_resolution_image_url" :alt="game.name">
		</div>

		<div v-if="!game.fps[resolution]" class="tooltip-container">
			<tooltip class-binding="fps-tooltip-starter-series">
				{{ fpsPendingMessage }}
			</tooltip>
		</div>
	</div>
</template>

<script>
import FpsBar from "./fps-bar";
import Tooltip from "@c/generals/tooltip";
import CONSTANTS from "@/config/constants";

export default {
	name: "GameFps",
	components: {
		FpsBar,
		Tooltip
	},
	props: {
		reverseContent: {
			type: Boolean,
			default: false
		},
		game: {
			type: Object,
			required: true
		},
		resolution: {
			type: [String, Number],
			required: true
		}
	},
	data() {
		return {
			fpsPendingMessage: CONSTANTS.FPS_PENDING_MESSAGE
		};
	}
};
</script>

<style lang="scss" scoped>

.prebuild-game {
	position: relative;

	&__cover {
		width: 98px;
		height: 130px;

		img {
			width: 100%;
			height: 100%;
		}
	}

	.tooltip-container {
		display: none;
		position: absolute;
		z-index: 10;
		right: -100%;
		top: 82%;
	}
}

.prebuild-game:hover .tooltip-container {
	display: block;
}

.prebuild-game--reverse-content {
	display: flex;
	flex-direction: column-reverse;

	.prebuild-game__cover {
		margin-bottom: 8px;
	}
}
</style>
